import { render, staticRenderFns } from "./DynamicCell.vue?vue&type=template&id=66230616&scoped=true"
import script from "./DynamicCell.vue?vue&type=script&lang=js"
export * from "./DynamicCell.vue?vue&type=script&lang=js"
import style0 from "./DynamicCell.vue?vue&type=style&index=0&id=66230616&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66230616",
  null
  
)

export default component.exports